module.exports = __webpack_public_path__ + "static/media/not-supported-mymall.18a23c58.svg";